// The Netwatch mark, drawn once.
//
// It lived inside Outlook.tsx, which was fine while the posture line was its
// only user. The alert-cluster tile now wears it too, and AlertCluster cannot
// import from Outlook — Outlook already imports AlertCluster, so that way lies
// a cycle. One module, one drawing: two hand-copied SVGs would drift the first
// time either stroke changed.

export function AtomMark() {
  return (
    <svg width="22" height="22" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      {/* Token, not a literal: hard-coded, the mark stayed dark-theme blue on
          the light surface while everything around it flipped. */}
      <g stroke="var(--accent)">
        <path d="M24 4 L41.3 14 L41.3 34 L24 44 L6.7 34 L6.7 14 Z" strokeWidth="2.6" opacity=".5" />
        <path d="M24 13 L33.5 18.5 L33.5 29.5 L24 35 L14.5 29.5 L14.5 18.5 Z" strokeWidth="2.4" />
      </g>
      <circle cx="24" cy="24" r="3.2" fill="var(--ink)" />
    </svg>
  )
}
